// Returns the pixel height an image occupies when rendered at `width`, derived
// from its intrinsic dimensions. Emitting this as the `height` attribute (next
// to `style="height:auto"`) makes a blocked or images-off image reserve its box
// instead of collapsing to 0px — which otherwise shifts the rest of a column up
// and throws two-column layouts out of phase (FE-1128).
//
// Returns undefined when any input is missing or unusable, so callers can simply
// omit the attribute and fall back to the previous behavior.
const reservedImageHeight = (width, naturalWidth, naturalHeight) => {
  const w = parseFloat(width)
  const nw = parseFloat(naturalWidth)
  const nh = parseFloat(naturalHeight)
  if (!w || !nw || !nh) {
    return undefined
  }
  return Math.round((w * nh) / nw)
}

export default reservedImageHeight
